// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var CommonTypes_Business = require("./business/CommonTypes_Business.bs.js");
var CommonTypes_WorkerMessage = require("./CommonTypes_WorkerMessage.bs.js");

function roster(param_0) {
  return /* Roster */{
          _0: param_0
        };
}

var Business = {
  code: /* Code */0,
  pastShifts: /* PastShifts */1,
  ratings: /* Ratings */2,
  roster: roster,
  upcomingShifts: /* UpcomingShifts */3
};

function businessInvite(param_0) {
  return {
          TAG: /* BusinessInvite */0,
          _0: param_0
        };
}

function workerMessage(param_0) {
  return {
          TAG: /* WorkerMessage */1,
          _0: param_0
        };
}

var Professional = {
  appStore: /* AppStore */0,
  availability: /* Availability */1,
  businessInvite: businessInvite,
  cancellationPolicy: /* CancellationPolicy */2,
  certifications: /* Certifications */3,
  contactSupport: /* ContactSupport */4,
  experience: /* Experience */5,
  getShifts: /* GetShifts */6,
  help: /* Help */7,
  home: /* Home */8,
  matchedShifts: /* MatchedShifts */9,
  myShifts: /* MyShifts */10,
  nextSteps: /* NextSteps */11,
  orientationCheckIn: /* OrientationCheckIn */12,
  payments: /* Payments */13,
  profile: /* Profile */14,
  profilePicture: /* ProfilePicture */15,
  referral: /* Referral */16,
  workerMessage: workerMessage
};

function business(param_0) {
  return {
          TAG: /* Business */0,
          _0: param_0
        };
}

function professional(param_0) {
  return {
          TAG: /* Professional */1,
          _0: param_0
        };
}

function fromURLParts(param) {
  if (!param) {
    return /* NoDeepLink */0;
  }
  switch (param.hd) {
    case "availability" :
        if (param.tl) {
          return /* Unknown */1;
        } else {
          return {
                  TAG: /* Professional */1,
                  _0: /* Availability */1
                };
        }
    case "business-invite" :
        var match = param.tl;
        if (match && !match.tl) {
          return Relude_Option.fold(/* Unknown */1, (function (param) {
                        return Relude_Globals.$great$great(businessInvite, professional, param);
                      }), Curry._1(CommonTypes_Business.ShiftInviteCode.fromString, match.hd));
        } else {
          return /* Unknown */1;
        }
    case "cancelpolicy" :
        if (param.tl) {
          return /* Unknown */1;
        } else {
          return {
                  TAG: /* Professional */1,
                  _0: /* CancellationPolicy */2
                };
        }
    case "certs" :
        if (param.tl) {
          return /* Unknown */1;
        } else {
          return {
                  TAG: /* Professional */1,
                  _0: /* Certifications */3
                };
        }
    case "experience" :
        if (param.tl) {
          return /* Unknown */1;
        } else {
          return {
                  TAG: /* Professional */1,
                  _0: /* Experience */5
                };
        }
    case "get-shifts" :
        if (param.tl) {
          return /* Unknown */1;
        } else {
          return {
                  TAG: /* Professional */1,
                  _0: /* GetShifts */6
                };
        }
    case "help" :
        if (param.tl) {
          return /* Unknown */1;
        } else {
          return {
                  TAG: /* Professional */1,
                  _0: /* Help */7
                };
        }
    case "home" :
        if (param.tl) {
          return /* Unknown */1;
        } else {
          return {
                  TAG: /* Professional */1,
                  _0: /* Home */8
                };
        }
    case "matches" :
        if (param.tl) {
          return /* Unknown */1;
        } else {
          return {
                  TAG: /* Professional */1,
                  _0: /* MatchedShifts */9
                };
        }
    case "mycode" :
        if (param.tl) {
          return /* Unknown */1;
        } else {
          return {
                  TAG: /* Business */0,
                  _0: /* Code */0
                };
        }
    case "myshifts" :
        if (param.tl) {
          return /* Unknown */1;
        } else {
          return {
                  TAG: /* Professional */1,
                  _0: /* MyShifts */10
                };
        }
    case "nextsteps" :
        if (param.tl) {
          return /* Unknown */1;
        } else {
          return {
                  TAG: /* Professional */1,
                  _0: /* NextSteps */11
                };
        }
    case "oricheckin" :
        if (param.tl) {
          return /* Unknown */1;
        } else {
          return {
                  TAG: /* Professional */1,
                  _0: /* OrientationCheckIn */12
                };
        }
    case "pastshifts" :
        if (param.tl) {
          return /* Unknown */1;
        } else {
          return {
                  TAG: /* Business */0,
                  _0: /* PastShifts */1
                };
        }
    case "payments" :
        if (param.tl) {
          return /* Unknown */1;
        } else {
          return {
                  TAG: /* Professional */1,
                  _0: /* Payments */13
                };
        }
    case "profile" :
        if (param.tl) {
          return /* Unknown */1;
        } else {
          return {
                  TAG: /* Professional */1,
                  _0: /* Profile */14
                };
        }
    case "profilepic" :
        if (param.tl) {
          return /* Unknown */1;
        } else {
          return {
                  TAG: /* Professional */1,
                  _0: /* ProfilePicture */15
                };
        }
    case "r" :
        var match$1 = param.tl;
        if (match$1 && !match$1.tl) {
          return Relude_Option.fold(/* Unknown */1, (function (param) {
                        return Relude_Globals.$great$great(workerMessage, professional, param);
                      }), Curry._1(CommonTypes_WorkerMessage.UniqueCode.fromString, match$1.hd));
        } else {
          return /* Unknown */1;
        }
    case "ratings" :
        if (param.tl) {
          return /* Unknown */1;
        } else {
          return {
                  TAG: /* Business */0,
                  _0: /* Ratings */2
                };
        }
    case "referral" :
        if (param.tl) {
          return /* Unknown */1;
        } else {
          return {
                  TAG: /* Professional */1,
                  _0: /* Referral */16
                };
        }
    case "support" :
        if (param.tl) {
          return /* Unknown */1;
        } else {
          return {
                  TAG: /* Professional */1,
                  _0: /* ContactSupport */4
                };
        }
    case "roster" :
    case "u" :
        break;
    case "upcomingshifts" :
        if (param.tl) {
          return /* Unknown */1;
        } else {
          return {
                  TAG: /* Business */0,
                  _0: /* UpcomingShifts */3
                };
        }
    default:
      return /* Unknown */1;
  }
  var match$2 = param.tl;
  if (match$2 && !match$2.tl) {
    return Relude_Option.fold(/* Unknown */1, (function (param) {
                  return Relude_Globals.$great$great(roster, business, param);
                }), Curry._1(CommonTypes_WorkerMessage.UniqueCode.fromString, match$2.hd));
  } else {
    return /* Unknown */1;
  }
}

var partial_arg = /^(https?:\/\/[^\/]+)\/?/;

function partial_arg$1(param) {
  return Relude_String.replaceRegex(partial_arg, "", param);
}

function partial_arg$2(param) {
  return Relude_Globals.$great$great(partial_arg$1, (function (param) {
                return Relude_String.splitAsList("/", param);
              }), param);
}

function fromURLString(param) {
  return Relude_Globals.$great$great(partial_arg$2, fromURLParts, param);
}

function fromURLStringToBusinessDeepLink(param) {
  return Relude_Globals.$great$great(fromURLString, (function (deepLink) {
                if (typeof deepLink === "number" || deepLink.TAG !== /* Business */0) {
                  return ;
                } else {
                  return deepLink._0;
                }
              }), param);
}

function fromURLStringToProDeepLink(param) {
  return Relude_Globals.$great$great(fromURLString, (function (deepLink) {
                if (typeof deepLink === "number") {
                  if (deepLink === /* NoDeepLink */0) {
                    return ;
                  } else {
                    return /* AppStore */0;
                  }
                } else if (deepLink.TAG === /* Business */0) {
                  return ;
                } else {
                  return deepLink._0;
                }
              }), param);
}

var noDeepLink = /* NoDeepLink */0;

var unknown = /* Unknown */1;

exports.Business = Business;
exports.Professional = Professional;
exports.business = business;
exports.professional = professional;
exports.noDeepLink = noDeepLink;
exports.unknown = unknown;
exports.fromURLParts = fromURLParts;
exports.fromURLString = fromURLString;
exports.fromURLStringToBusinessDeepLink = fromURLStringToBusinessDeepLink;
exports.fromURLStringToProDeepLink = fromURLStringToProDeepLink;
/* Relude_Option Not a pure module */
